<template>
  <div class="search">    
    <h1 class="titulo">Área do cliente - <span class="titulo-pequeño">Perguntas frequentes</span></h1>
    <logout-menu></logout-menu>
    <div class="content">
      <div class="faq">
        <div class="title">
          Perguntas frequentes
        </div>

        <div>
          <div class="section" v-for="section in sections" :key="section.title">
            <div class="title" @click="toggleSection(section)">
              <div class="arrow" :class="section.toggle ? 'rotate90' : ''">
                <span class="pink-title">></span>
              </div> {{ section.title }}
            </div>
            <transition name="list">
              <div class="section-container" v-if="section.toggle">
                <div class="question-container" v-for="(content, qindex) in section.content" :key="'question-' + qindex">
                  <div class="question" @click="toggleQuestion(content)">
                    <div class="arrow" :class="content.toggle ? 'rotate90' : ''">
                      <span class="pink-title">></span>
                    </div> 
                    {{ content.question }}
                  </div>
                  <transition name="list">
                    <div class="answer" v-if="content.toggle">
                      <div>
                        {{ content.answer }}
                      </div>

                      <div v-if="content.additional_answers !== undefined">
                        <div v-for="(answer, aindex) in content.additional_answers" :key="'answer-' + qindex + '-' + aindex">
                          <div class="superior-answer">
                            {{ answer.superior }}
                          </div>

                          <div class="inferior-answer" v-for="(inferior, iindex) in answer.inferior" :key="'answer-' + qindex + '-' + aindex + '-' + iindex">
                            {{ inferior }}
                          </div>
                        </div>
                      </div>

                      <div v-if="content.additional_content !== undefined" class="image-container">
                        <img :src="require('@/assets/' + content.additional_content)"/>
                      </div>
                    </div>
                  </transition>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LogoutMenu from '../components/LogoutMenu.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'Search',
  data () {
    return {
      sections: [
        {
          title: 'Fatura',
          content: [
            {
              question: 'Como sou cobrado? Que ciclo de faturação eu tenho?',
              answer: 'R. Faturamos em meses do calendário, isto é do dia 1 ao dia 30 de cada mês. Lembre-se que a nossa faturaçao é antecipada, portanto, no início de cada mês você paga a conta do mês corrente.'
            }, {
              question: 'Em que data será feita a cobrança no banco?',
              answer: 'R. O débito será efectuado na sua conta bancária nos primeiros 5 dias do mês.'
            }, {
              question: 'A data de cobrança ao banco pode ser alterada?',
              answer: 'R. Temos apenas um ciclo de cobrança, então não podemos alterar as datas das cobranças bancárias.'
            }, {
              question: 'Como vou receber minha fatura?',
              answer: 'R. Você receberá sua fatura por e-mail no início de cada mês, antes de receber a cobrança no banco. Estão também disponíveis na secção Faturas da Área do Cliente.'
            }, {
              question: 'Como posso pagar uma fatura devolvida?',
              answer: 'R. Pode ligar-nos para o 800450118 para efetuar o pagamento ou efetuar uma transferência para o número de conta que indicamos na mensagem onde lhe informamos o valor da fatura pendente. Em todo o caso deverá utilizar a referência de pagamento que lhe enviamos por email. Se você pagar por transferência precisaremos de 24/48 horas para localizar o pagamento, nas restantes formas de pagamento ele será reconhecido automaticamente. '
            }
          ]
        }, {
          title: 'Informações gerais',
          content: [
            {
              question: 'Com que tecnologias trabalhamos?',
              answer: 'R. Somos uma empresa que chega usando satélite.'
            }
          ]
        }, {
          title: 'Produtos e serviços',
          content: [
            {
              additional_answers: [
                {
                  superior: '• Para todas as chamadas: Com isso, TODAS as chamadas vão para o correio de voz.',
                  inferior: [
                    'ou é ativado com: **21*242#',
                    'ou está desativado com: ##21#'
                  ]
                }, {
                  superior: '• Para quando estamos sem cobertura ou com o telefone desligado: Útil se desligarmos o celular, ficar sem bateria ou estivermos no modo avião.',
                  inferior: [
                    'ou Ativado com: **62*242#',
                    'ou está desativado com: ##62#'
                  ]
                }, {
                  superior: '• Para quando a linha estiver ocupada: se estivermos conversando e não quisermos perder chamadas.',
                  inferior: [
                    'ou Ativado com: **67*242#',
                    'ou está desativado com: ##67#'
                  ]
                }, {
                  superior: '• No caso de você não atender: Útil se deixarmos o celular ou não tivermos tempo para atender uma chamada',
                  inferior: [
                    'ou Ativado com: **61*242#',
                    'ou está desativado com: ##61#'
                  ]
                }, {
                  superior: '• Desativar qualquer encaminhamento: Com isso cancelamos qualquer tipo de encaminhamento que tenhamos ativado, inclusive o encaminhamento para outros números que não a secretária eletrônica.',
                  inferior: [
                    'ou O código é ##002#'
                  ]
                }
              ]
            }, {
              question: 'Como ver quais os produtos eu contratei?',
              answer: 'R. Poderá consultar os produtos que contratou na secção Os Meus Produtos da Área do Cliente. Além disso, os produtos que você contratou estão refletidos na fatura.'
            }, {
              question: 'Como posso solicitar uma alteração no meu serviço?',
              answer: 'R. Pode modificar os serviços que contratou no nosso Serviço de Apoio ao Cliente, ligando para 800450118 ou enviando um email para apoiocliente@eurona.com'
            }, {
              question: 'Que volume de dados contratei e o que posso fazer com eles?',
              answer: 'R. Cada produto possui um volume de dados mensal dependendo da taxa contratada.',
            }, {
              question: 'Como posso saber o consumo de dados do mês atual?',
              answer: 'R. Poderá consultar essa informaçao na área de cliente “ Consumo”.'
            }, {
              question: 'Como posso expandir a capacidade de GB que contratei?',
              answer: 'R. Você poderá contratar dados adicionais sempre que, ligando para o nosso atendimento ao cliente (800450118), você também pode alterar para uma taxa que melhor se adapte às suas necessidades de uso.'
            }, {
              question: 'As soluções de internet incluem manutenção?',
              answer: 'R. Dispomos de soluções à medida que incluem este serviço. Pode contratar a manutenção com permanência com um valor mensal de 3,69€/mês (IVA incluído), por um período de 12 meses, que renova automaticamente. Também pode contratar o serviço de manutenção sem permanência, com um custo anual de 123€ (IVA incluído),  passados os 12 meses tem que contactar o apoio ao cliente para a sua renovação.'
            }, {
              question: 'Como posso desistir?',
              answer: 'R. Não queremos que saia, mas se pretender cancelar o seu serviço, deverá contactar o nosso Serviço de Apoio ao Cliente através do número 800450118.'
            }, {
              question: 'Como posso fazer a alteração de titular?',
              answer: 'R. Para proceder a uma alteração de titular, necessitamos que o antigo e novo titular forneçam a documentação de identificação, assinem e preencham o formulário de alteração de titular. O formulário será enviado pelo nosso apoio ao cliente quando necessário, através do numero 800450118 ou enviando um email para o apoiocliente@eurona.com. Esta alteração poderá ter custos de gestão.'
            }, {
              question: 'Como posso modificar minhas informações de contato?',
              answer: 'R. Temos como contactos o telefone e o correio que nos deixou aquando da assinatura do contrato, caso tenham mudado ligue-nos para o 800450118 para que possamos actualizá-los. Também pode atualizar os seus dados na área de cliente, na janela “Meus dados'
            }
          ]
        }, {
          title: 'Inquéritos técnicos',
          content: [
            {
              question: 'Minha conexão funciona para assistir TV online (Nexflix, HBO, YouTube...)?',
              answer: 'R. Sim, você pode assistir TV online com sua conexão em qualidade básica sem nenhum problema.'
            }, {
              question: 'Minha conexão funciona para jogos online?',
              answer: 'R. As conexões via satélite não são adequadas para esse tipo de uso pois a conexão entre seu computador/console e o servidor tem um atraso de cerca de meio segundo, lembre-se que os dados têm que viajar até o satélite e voltar (aproximadamente 50.000 km ), o que o torna inadequado para jogos em tempo real. Se você tiver dúvidas sobre como ver qual produto contratou, consulte a seção 9'
            }, {
              question: 'É possível configurar uma VPN?',
              answer: 'R. A tecnologia de satélite é incompatível para o uso de jogos online em tempo real e VPNs, pois são afetados pela latência.'
            }, {
              question: 'Posso contratar um serviço de IP Fixo?',
              answer: 'R. Este momento, este serviço não se encontra disponível. '
            }, {
              question: 'A que velocidade posso navegar com minha conexão?',
              answer: 'R. Os produtos que você contratou estão refletidos na fatura. Você tem uma linha com sua conexão de internet onde, além do tipo de produto, você pode ver em seu contrato a velocidade de conexão priorizada que você contratou. Tenha em mente que esta é uma velocidade que pode ser afetada por diferentes efeitos, como o número de dispositivos que você conectou ao mesmo tempo ou se você usa uma conexão Wi-Fi ou cabo'
            }, {
              question: 'Minha conexão caiu? Que posso fazer?',
              answer: 'R. Se você tiver problemas com a conexão tente seguir estes passos:',
              additional_answers: [
                {
                  superior: '- Se a conexão estiver mais lenta que o normal, verifique se você não consumiu o volume de dados que possui com a velocidade máxima contratada, pois a partir desse momento a velocidade da conexão é reduzida. Você deve ter recebido um SMS informando que você excedeu este volume de dados.',
                }, {
                  superior: '-	Garante que o equipamento esteja corretamente conectado à rede elétrica.',
                }, {
                  superior: '-	Reinicie o equipamento (modem e/ou roteador) para solucionar um possível bloqueio.',
                }, {
                  superior: 'Se após estas etapas você continuar sem recuperar a conexão, ligue para 800450118 e selecione a opção "suporte técnico".',
                }
              ]
            }
          ]
        }
      ]
    }
  },
  mounted () {
    if (!this.logged) {
      this.$router.push("/")
    }
  },  
  methods: {
    toggleSection (section) {
      this.$set(section, 'toggle', section.toggle === null ? true : !section.toggle)
    },
    toggleQuestion (content) {
      this.$set(content, 'toggle', content.toggle === null ? true : !content.toggle)
    }
  },
  computed: {
    ...mapGetters(['logged'])
  },  
  components: { LogoutMenu }
}
</script>

<style scoped>
  .faq {
    padding: 0px 30px;
  }

  .section {
    margin: 0 auto;
    padding: 10px;
  }

  .title {
    float: left;
    margin: 0 auto;
    margin-top: 15px;
    font-weight: bold;
    width: 100%;
    cursor: pointer;
  }

  .question-container {
    clear: both;
    border: 0.5px solid pink;
    border-radius: 15px;
    padding: 10px;
    margin-bottom: 10px;
    height: max-content;
  }

  .question {
    font-size: 18px;
    cursor: pointer;
  }

  .section-container, .answer {
    padding: 5px 10px 0 10px;
    overflow: hidden;
    height: max-content;
  }

  .superior-answer {
    padding-top: 10px;
    padding-left: 20px;
  }

  .inferior-answer {
    padding-left: 40px;
  }

  .pink-title {
    color: var(--fucsia-1);
    font-size: 12px;
    font-weight: bold;
  }

  .arrow {
    float: left;
    width: 20px;
    height: 20px;
    text-align: center;
  }

  .rotate90 {
    transform: translateY(-100%) rotate(90deg);
    transform-origin: bottom left;
  }

  .image-container {
    float: left;
    text-align: center;
    width: 100%;
  }

  .image-container > img {
    margin: 0 auto;
    max-width: 1024px;
  }

  .list-enter,
  .list-leave-to {
    visibility: hidden;
    height: 0;
    margin: 0;
    padding: 0;
    opacity: 0;
  }

  .list-enter-active,
  .list-leave-active {
    transition: all 0.3s;
  }

  @media (max-width: 768px) {
    .image-container > img {
      max-width: 100%;
    }
    .faq {
      padding: 0px;
      margin-bottom: 50px;
    }    
  }
</style>